export const FARE_TYPE = {
  NORMAL: 'M',
  PROMO: 'P'
}
